import { useProfilePreview } from "PFApp/use_profile_preview";
import { Button } from "PFComponents/button";
import { getProfileName } from "PFCore/helpers/profile";
import { Profile } from "PFTypes";
import React from "react";

import css from "../workforce.module.scss";

export const UserCell = ({ profile }: { profile: Profile }) => {
  const { showPreview } = useProfilePreview();

  return (
    <Button
      kind="text"
      theme={{ root: css.cellEntry }}
      onClick={() => showPreview({ id: profile.id, profile })}
    >
      {getProfileName(profile)}
    </Button>
  );
};
